import {
        setSucursalUuid,
        removeSucursalUuid,
        setCajaId,
        removeCajaId,
} from './contexto';

export function SET_SUCURSALES(state, sucursales) {
        state.sucursales = sucursales

}
export function SET_SUCURSAL(state, sucursal) {
        state.sucursal = sucursal

}

export function SET_CAJA(state, caja) {
        state.caja = caja

}
export function SET_ARQUEO_CAJA(state, arqueo) {
        console.log("Dentro de SET_ARQUEO_CAJA, ", arqueo);


        state.arqueoCaja = arqueo



}


export function SET_CAJA_ID_COOKIE(state, id) {
        setCajaId(id);
}
export function DELETE_CAJA_COOKIE(state) {
        removeCajaId();
}


export function SET_CONFIGURACION(state, configuracion) {
        state.configuracion = configuracion

}
export function SET_SUCURSAL_UUID_COOKIE(state, uuid) {
        setSucursalUuid(uuid);
}
export function DELETE_SUCURSAL_COOKIE(state) {
        removeSucursalUuid();
}
